import { Navigate, useLocation, useParams } from 'react-router';

/**
 * URLs antiguas `/checkout/:feeCode/documento` redirigen a `/home`.
 */
export default function CheckoutDocumentoRedirect() {
  const { feeCode } = useParams();
  const { state } = useLocation() as { state?: { sindicatoId?: number | null } };
  const code = feeCode === 'AGREEMENT' || feeCode === 'NO_AGREEMENT' ? feeCode : null;
  return (
    <Navigate
      to="/home"
      replace
      state={{ sindicatoId: state?.sindicatoId, feeCode: code }}
    />
  );
}
